import { lazy } from "react";
import { Route, Routes } from "react-router-dom";
import { ViewIps } from "../../view/private/ips/viewIps";
import { ViewIpsLovelace } from "../../view/private/ips/ViewLovelace";
import { ViewIpsMovil } from "../../view/private/ips/ViewMovil";
import { CreateUser } from "../../view/private/user/CreateUser";
import { ViewUser } from "../../view/private/user/ViewUser";
import { UpdateUser } from "../../view/private/user/UpdateUser";
import { ViewSupport } from "../../view/private/support/ViewSupport";
import { CreateSupport } from "../../view/private/support/CreateSupport";
import { ViewSupportFinal } from "../../view/private/support/ViewSupport_final";
import { RockyHeader } from "../../view/private/main/RockyHeader";
import { ViewSupportMY } from "../../view/private/support/VierwMySupports";
import { ViewCreateMuni } from "../../view/private/municipality/listCreate";
import { ViewTemplateAll } from "../../view/private/template/ViewTemplate";
import { CreateTemplate } from "../../view/private/template/CreateTemplate";
import { ViewMyTemplate } from "../../view/private/template/MyTemplate";
import { ViewSendSupport } from "../../view/private/support/ViewSendSupport";
import { LoginPrivate } from "../../view/private/auth/authprivate";
import { InternarGuard } from "../../segurity/InternalGuard";
import { AdminSupport } from "../../view/private/support/AdminSupport";
import { ViewAuthDevice } from "../../view/private/authorizedDevice/ViewAuthDevice";
import { Error4040 } from "../../view/public/Error4040";
import { ListAllNews } from "../../view/private/news/List";
import { CreateNews } from "../../view/private/news/Create";
import { ViewCreditor } from "../../view/private/portfolioCleanup/creditor/List";
import { ViewConciliation } from "../../view/private/portfolioCleanup/conciliation/List";
import { ViewPacts } from "../../view/private/portfolioCleanup/pacts/List";
import { ViewProgress } from "../../view/private/portfolioCleanup/progress/List";
import { ViewConPacts } from "../../view/private/portfolioCleanup/pacts/ConPacts";
import { ViewPacProgress } from "../../view/private/portfolioCleanup/progress/PacProgress";
import { AllData } from "../../view/private/portfolioCleanup/Condensate/AllData";
import { ListEPS } from "../../view/private/eps/ListEPS";
import { ListTypeReport } from "../../view/private/TypeReport/ListTypeReport";

// const LazyLogin = lazy(() =>
//   import("../../view/auth/shared/Login").then(() => ({ default: Login }))
// );

// import { CREATE_USER } from "../../view/private/user/Create"

// const LazyProfessionalCreate =lazy(()=>import("../../view/private/user/Create").then(()=>({default:CreateProfessional})));
const LazyIPSView = lazy(() =>
  import("../../view/private/ips/viewIps").then(() => ({ default: ViewIps }))
);
const LazyIPSViewLovelace = lazy(() =>
  import("../../view/private/ips/ViewLovelace").then(() => ({ default: ViewIpsLovelace }))
);
const LazyIPSViewMovil = lazy(() =>
  import("../../view/private/ips/ViewMovil").then(() => ({ default: ViewIpsMovil }))
);
const LazyUserCreate = lazy(() =>
  import("../../view/private/user/CreateUser").then(() => ({
    default: CreateUser,
  }))
);

const Lazymain = lazy(() =>
  import("../../view/private/main/RockyHeader").then(() => ({
    default: RockyHeader,
  }))
);

const LazyUserView = lazy(() =>
  import("../../view/private/user/ViewUser").then(() => ({
    default: ViewUser,
  }))
);
const LazyUserUpdate = lazy(() =>
  import("../../view/private/user/UpdateUser").then(() => ({
    default: UpdateUser,
  }))
);

const LazySupportView = lazy(() =>
  import("../../view/private/support/ViewSupport").then(() => ({
    default: ViewSupport,
  }))
);

const LazySupportViewFinal = lazy(() =>
  import("../../view/private/support/ViewSupport_final").then(() => ({
    default: ViewSupportFinal,
  }))
);

const LazySupportCreate = lazy(() =>
  import("../../view/private/support/CreateSupport").then(() => ({
    default: CreateSupport,
  }))
);

const LazyupportMySupport = lazy(() =>
  import("../../view/private/support/VierwMySupports").then(() => ({
    default: ViewSupportMY,
  }))
);
const LazyupportMyMunicipality = lazy(() =>
  import("../../view/private/municipality/listCreate").then(() => ({
    default: ViewCreateMuni,
  }))
);
const LazyViewTemplate = lazy(() =>
  import("../../view/private/template/ViewTemplate").then(() => ({
    default: ViewTemplateAll,
  }))
);
const LazyCreateTemplate = lazy(() =>
  import("../../view/private/template/CreateTemplate").then(() => ({
    default: CreateTemplate,
  }))
);
const LazyViewMyTemplate = lazy(() =>
  import("../../view/private/template/MyTemplate").then(() => ({
    default: ViewMyTemplate,
  }))
);
const LazyViewSendSupport = lazy(() =>
  import("../../view/private/support/ViewSendSupport").then(() => ({
    default: ViewSendSupport,
  }))
);
const LazyViewLoginPrivate = lazy(() =>
  import("../../view/private/auth/authprivate").then(() => ({
    default: LoginPrivate,
  }))
);
const LazyViewAdminSupport = lazy(() =>
  import("../../view/private/support/AdminSupport").then(() => ({
    default: AdminSupport,
  }))
);
const LazyViewAuthDevice = lazy(() =>
  import("../../view/private/authorizedDevice/ViewAuthDevice").then(() => ({
    default: ViewAuthDevice,
  }))
);
const LazyViewAllNews = lazy(() =>
  import("../../view/private/news/List").then(() => ({
    default: ListAllNews,
  }))
);
const LazyCreateNews = lazy(() =>
  import("../../view/private/news/Create").then(() => ({
    default: CreateNews,
  }))
);
const LazyListCreditor = lazy(() =>
  import("../../view/private/portfolioCleanup/creditor/List").then(() => ({
    default: ViewCreditor,
  }))
);
const LazyListConciliation = lazy(() =>
  import("../../view/private/portfolioCleanup/conciliation/List").then(() => ({
    default: ViewConciliation,
  }))
);
const LazyListPact= lazy(() =>
  import("../../view/private/portfolioCleanup/pacts/List").then(() => ({
    default: ViewPacts,
  }))
);
const LazyListProgress= lazy(() =>
  import("../../view/private/portfolioCleanup/progress/List").then(() => ({
    default: ViewProgress,
  }))
);
const LazyListCondesate= lazy(() =>
  import("../../view/private/portfolioCleanup/Condensate/AllData").then(() => ({
    default: AllData,
  }))
);

const LazyListPactProgress= lazy(() =>
  import("../../view/private/portfolioCleanup/progress/PacProgress").then(() => ({
    default: ViewPacProgress,
  }))
);
const LazyListConsPacts= lazy(() =>
  import("../../view/private/portfolioCleanup/pacts/ConPacts").then(() => ({
    default: ViewConPacts,
  }))
);
const NotFound = lazy(() =>
  import("../../view/public/Error4040").then(() => ({ default: Error4040 }))
);
const LazyListEPS = lazy(() =>
  import("../../view/private/eps/ListEPS").then(() => ({ default: ListEPS }))
);
const LazyListTypeReport = lazy(() =>
  import("../../view/private/TypeReport/ListTypeReport").then(() => ({ default: ListTypeReport }))
);
export const InternalRouting = () => {
  return (
    <Routes>
      {/* <Route path="/professional-view" element={<LazyProfessionalView/>}/> */}
      <Route path="/ips-view" element={<LazyIPSView />} />
      <Route path="/ips-view-lovelace" element={<LazyIPSViewLovelace />} />
      <Route path="/ips-view-movil" element={<LazyIPSViewMovil />} />
      <Route path="/main" element={<Lazymain />} />
      <Route path="/create-user" element={<LazyUserCreate />} />
      <Route path="/view-user" element={<LazyUserView />} />
      <Route path="/update-user/:id" element={<LazyUserUpdate />} />
      <Route path="/support-view" element={<LazySupportView />} />
      <Route path="/support-view-final" element={<LazySupportViewFinal />} />
      <Route path="/view-send-support" element={<LazyViewSendSupport />} />
      <Route path="/create-support" element={<LazySupportCreate />} />
      <Route path="/view-mysupport" element={<LazyupportMySupport />} />
      <Route
        path="/view-create-municipality"
        element={<LazyupportMyMunicipality />}
      />
      <Route path="/view-template" element={<LazyViewTemplate />} />
      <Route path="/create-template" element={<LazyCreateTemplate />} />
      <Route path="/view-my-template" element={<LazyViewMyTemplate />} />
      <Route path="/view-login-private" element={<LazyViewLoginPrivate />} />
      <Route path="/view-auth-device" element={<LazyViewAuthDevice />} />
      <Route path="/view-all-news" element={<LazyViewAllNews />} />
      <Route path="/create-news" element={<LazyCreateNews />} />
      <Route path="/list-creditor" element={<LazyListCreditor />} />
      <Route path="/list-conciliation" element={<LazyListConciliation />} />
      <Route path="/list-pact" element={<LazyListPact />} />
      <Route path="/list-progress" element={<LazyListProgress />} />
      <Route path="/list-condesate" element={<LazyListCondesate />} />

      <Route path="/list-pac-progress/:id_pacts/:name_creditor/:ips_name/:date_conciliation/:num_certificate/:balance/:explanation/:refund/:id_creditor__type_creditor/:id_creditor__document_creditor/:id_ips__municipio_id__codigo_municipio/:balance_conciliation" element={<LazyListPactProgress />} />
      <Route path="/list-cons-pacts/:id_concilia/:name_creditor/:ips_name/:programming/:date_conciliation/:modality_con/:balance/:explanation/:refund/:id_creditor__type_creditor/:id_creditor__document_creditor/:id_ips__municipio_id__codigo_municipio" element={<LazyListConsPacts />} />
      <Route element={<InternarGuard />}>
        <Route path="/view-dashbord" element={<LazyViewAdminSupport />} />
      </Route>

      {/* support inofrmation */}
      <Route path="/list-eps" element={<LazyListEPS />} />
      <Route path="/list-type-report" element={<LazyListTypeReport />} />

      <Route />
      <Route path="*" element={<NotFound />} />
    </Routes>
  );
};
